import { render, staticRenderFns } from "./InputRadioButtons.vue?vue&type=template&id=e28f9d4e&scoped=true&"
import script from "./InputRadioButtons.vue?vue&type=script&lang=ts&"
export * from "./InputRadioButtons.vue?vue&type=script&lang=ts&"
import style0 from "./InputRadioButtons.vue?vue&type=style&index=0&id=e28f9d4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28f9d4e",
  null
  
)

export default component.exports